import { z } from 'zod';

/**
 * The signed-in user, as `GET /api/me` returns it (F6 AC-1.1, AC-2.1). Only what the apps show: no
 * session, token, ban details or provider data. Adding a field is additive; renaming one is breaking.
 */

export const MeRoleSchema = z.enum(['user', 'editor', 'admin']);
export type MeRole = z.infer<typeof MeRoleSchema>;

export const MeResponseSchema = z.strictObject({
  id: z.string().min(1),
  email: z.string().min(1),
  /** Display name; `null` when the user has none (Better Auth stores an empty string for OTP sign-up). */
  name: z.string().min(1).nullable(),
  role: MeRoleSchema,
  /** ISO 8601 UTC (`2026-10-17T08:30:00.000Z`). */
  createdAt: z.iso.datetime(),
  /** Last activity, written at most once an hour (F6 T-2.5); `null` before the first write. */
  lastSeenAt: z.iso.datetime().nullable(),
});
export type MeResponse = z.infer<typeof MeResponseSchema>;
